import api from './api'

export const therapyDashboardService = {
  getDashboardData(params = {}) {
    const query = new URLSearchParams()
    if (params.storeId) query.append('storeId', params.storeId)
    if (params.therapistId) query.append('therapistId', params.therapistId)
    if (params.activityId) query.append('activityId', params.activityId)
    if (params.startDate) query.append('startDate', params.startDate)
    if (params.endDate) query.append('endDate', params.endDate)
    return api.get(`/therapy/statistics/dashboard?${query.toString()}`)
  },

  async exportBookings(params = {}) {
    const query = new URLSearchParams()
    if (params.storeId) query.append('storeId', params.storeId)
    if (params.therapistId) query.append('therapistId', params.therapistId)
    if (params.activityId) query.append('activityId', params.activityId)
    if (params.startDate) query.append('startDate', params.startDate)
    if (params.endDate) query.append('endDate', params.endDate)
    try {
      const res = await api.get(`/therapy/statistics/dashboard/bookings/export?${query.toString()}`, {
        responseType: 'blob',
        timeout: 120000
      })
      const blob = res.data
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      const dateStr = params.endDate || new Date().toISOString().split('T')[0]
      a.download = `therapy-bookings-${dateStr}.xlsx`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      const blob = error?.response?.data
      if (blob instanceof Blob) {
        const text = await blob.text()
        try {
          const json = JSON.parse(text)
          const err = new Error(json.error || json.message || '导出失败')
          err.response = error.response
          throw err
        } catch (parseError) {
          if (parseError instanceof SyntaxError) {
            throw error
          }
          throw parseError
        }
      }
      throw error
    }
  },

  getStoreList() {
    return api.get('/therapy/store')
  },

  getTherapistList(params = {}) {
    const query = new URLSearchParams()
    if (params.status) query.append('status', params.status)
    query.append('page', 0)
    query.append('size', 100)
    return api.get(`/therapy/therapists?${query.toString()}`)
  },

  getActivityList(params = {}) {
    const query = new URLSearchParams()
    if (params.status) query.append('status', params.status)
    query.append('page', 0)
    query.append('size', 100)
    return api.get(`/therapy/activities?${query.toString()}`)
  }
}